import React, { Component } from "react";
import { FormControl, InputLabel, Select, Input, MenuItem, ListItemText } from "@material-ui/core";

export default class MechanicDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Mechanics: [],
		};
		this.getMechanics();
	}

	async getMechanics() {
		var data = await fetch("User/GetMechanics", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		});

		var res = await data.json();
		this.setState({ Mechanics: res });
	}

	render() {
		return (
			<FormControl style={{ minWidth: "250px", marginLeft: "15px" }}>
				<InputLabel id="mechanic-dropdown-label">Mechanic</InputLabel>
				<Select labelId="mechanic-dropdown-label" id="mechanic-dropdown" input={<Input />} onChange={this.props.OnChange}>
					{this.state.Mechanics.map((mech) => (
						<MenuItem key={mech.users_id} value={mech.users_id}>
							<ListItemText primary={mech.full_name} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		);
	}
}
